import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class ProfileDataStore {
    loading = false;
    editLoader = false;
    showReviewResponseModal = false;

    showModal = false;
    showUserEdit = false;
    showPhoneEdit = false;
    showCompanyEdit = false;
    showReviewModal = false;

    profile = null;

    getProfile = () => {
        this.loading = true;

        return Api.fetch('user/my')
            .then(response => {
                if (response.success) {
                    this.profile = response.result;
                    return response.result;
                }
            })
            .finally(() => {
                this.loading = false;
                return null;
            });
    };

    editContactData = (email, fio) => {
        this.editLoader = true;

        const data = {
            email,
            fio,
            utm: 'utm_lk',
        };

        Api.fetch('user/edit', data, 'POST')
            .then(response => (this.profile = response.result))
            .finally(() => {
                this.editLoader = false;
                this.showUserEdit = false;
            });
    };

    editCompanyData = (title, inn, city, address) => {
        this.editLoader = true;

        const data = {
            title,
            inn,
            city,
            address,
            utm: 'utm_lk',
        };

        Api.fetch('user/proposal', data, 'POST')
            .then(response => {
                if (response.success) {
                    this.showModal = true;
                }
            })
            .finally(() => {
                this.editLoader = false;
                this.showCompanyEdit = false;
            });
    };

    editPhone = phone => {
        this.editLoader = true;

        Api.fetch('user/change-phone', { phone }, 'POST')
            .then(response => {
                if (response.success) {
                    this.showModal = true;
                }
            })
            .finally(() => {
                this.editLoader = false;
                this.showPhoneEdit = false;
            });
    };

    hideModal = () => (this.showModal = false);

    showEditModal = id => {
        if (id === 'inn' || id === 'city' || id === 'legalAddress' || id === 'companyName') {
            this.showCompanyEdit = true;
        } else if (id === 'fio' || id === 'email') {
            this.showUserEdit = true;
        } else if (id === 'phone') {
            this.showPhoneEdit = true;
        }
    };

    closeEditModal = () => {
        this.showUserEdit = false;
        this.showPhoneEdit = false;
        this.showCompanyEdit = false;
    };

    sendReview = comment => {
        this.editLoader = true;
        const data = {
            comment,
        };

        Api.fetch('feedback/review', data, 'POST')
            .then(response => {
                if (response.success) {
                    this.showReviewResponseModal = true;
                }
            })
            .finally(() => {
                this.editLoader = false;
                this.showReviewModal = false;
            });
    };

    showReview = () => (this.showReviewModal = true);

    hideReview = () => (this.showReviewModal = false);

    hideReviewResponseModal = () => (this.showReviewResponseModal = false);

    resetStore = () => {
        this.loading = false;
        this.editLoader = false;
        this.showReviewResponseModal = false;

        this.showModal = false;
        this.showUserEdit = false;
        this.showPhoneEdit = false;
        this.showCompanyEdit = false;
        this.showReviewModal = false;

        this.profile = null;
    };
}

decorate(ProfileDataStore, {
    loading: observable,
    profile: observable,
    showModal: observable,
    showUserEdit: observable,
    showPhoneEdit: observable,
    showCompanyEdit: observable,
    showReviewModal: observable,
    editLoader: observable,
    showReviewResponseModal: observable,

    getProfile: action,
    editProfile: action,
    editCompanyData: action,
    editPhone: action,
    hideModal: action,
    showEditModal: action,

    sendReview: action,
    showReview: action,
    hideReview: action,
    hideReviewResponseModal: action,

    resetStore: action,
});
